export default __webpack_public_path__ + "static/media/coal-mine.9ffa206b.svg";